import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Contact from '../components/Contact';
import CategoriesGrid from '../components/CategoriesGrid';

const services2 = [
  {
    title: 'Consult',
    description: 'We offer you our cross-domain and technology expertise to optimize your solution’s efficiency and ROI.',
    image: 'c.jpg',
  },
  {
    title: 'Manage',
    description: '”Your Request, Our Responsibility” will be our project motto, ensuring that all your needs are met efficiently.',
    image: 'a.jpg',
  },
  {
    title: 'Merge',
    description: 'We seamlessly integrate with your team, bringing a product-focused mindset to drive your projects forward.',
    image: 'd.jpg',
  },

];

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Hero />
      <Services />
      <CategoriesGrid />
      <div>
        <div>
          <div className="relative">
            <h1 className="text-3xl pl-10 mt-12 w-5/6 lg:w-5/6 md:w-5/6 sm:pl-5 md:pl-10 lg:pl-20 sm:mt-6 md:mt-12 lg:mt-24 sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins sm:mb-8 leading-snug sm:leading-tight">
              Collaboration — we can wear any hat to meet your demands
            </h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-6 p-8">
            {services2.map((service, index) => (
              <div key={index} className="relative h-[35rem] flex flex-col items-start justify-start overflow-hidden rounded-lg bg-white">
                {/* صورة الخلفية */}
                <div
                  className="absolute inset-0 h-full w-full bg-cover bg-center"
                  style={{ backgroundImage: `url('/${service.image}')` }}
                >
                  <div className="absolute inset-0 h-full w-full"></div>
                </div>

                {/* النص */}
                <div className={`relative z-10 p-6 ${index === 1 ? 'text-black' : 'text-white'}`}>
                  <h3 className="text-2xl font-poppins font-bold">{service.title}</h3>
                  <p className="mt-2 font-poppins text-sm">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>


      </div>
      <Contact />
      <div className='mt-48' />
    </div>
  );
};

export default Home;
